<template>
  <b-row class="cameraContainer">
    <b-col lg="8" md="8" sm="12">
      <b-row v-if="imageSrc.length == 0">
        <video autoplay ref="video" class="videoComponent"></video>
        <button class="button is-hidden" ref="btnPlay" @click="play">
          <span class="icon is-small">
            <i class="fas fa-play"></i>
          </span>
        </button>
        <button class="button" ref="btnPause" @click="pause">
          <span class="icon is-small">
            <i class="fas fa-pause"></i>
          </span>
        </button>
        <button class="button is-success" @click="capture">
          <span class="icon is-small">
            <i class="fas fa-camera"></i>
          </span>
        </button>
        <button class="button" @click="switchCamera">
          <span class="icon">
            <i class="fas fa-sync-alt"></i>
          </span>
          <span>Switch camera</span>
        </button>
      </b-row>
      <b-row v-if="imageSrc.length > 0">
        <b-row ref="screenshotsContainer" class="screenshotsContainer">
          <img :src="imageSrc" class="pictureDraft" />
        </b-row>
        <b-row>
          <button class="button" @click="cancelDraft">Cancelar</button>
        </b-row>
      </b-row>
      <b-row>
        <canvas class="is-hidden" id="canvas" ref="canvas"></canvas>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  data: function () {
    return {
      constraints: {
        video: {
          //   width: {
          //     min: 1280,
          //     ideal: 1920,
          //     max: 2560,
          //   },
          //   height: {
          //     min: 720,
          //     ideal: 1080,
          //     max: 1440,
          //   },
          //
        },
      },
      imageSrc: "",
      videoStream: null,
      useFrontCamera: false,
    };
  },
  methods: {
    async initializeCamera() {
      this.stopVideoStream();
      this.constraints.video.facingMode = this.useFrontCamera
        ? "user"
        : "environment";

      try {
        this.videoStream = await navigator.mediaDevices.getUserMedia(
          this.constraints
        );
        this.$refs.video.srcObject = this.videoStream;
      } catch (err) {
        alert("Could not access the camera");
      }
    },
    play() {
      this.$refs.video.play();
      this.$refs.btnPlay.classList.add("is-hidden");
      this.$refs.btnPause.classList.remove("is-hidden");
    },
    pause() {
      this.$refs.video.pause();
      this.$refs.btnPause.classList.add("is-hidden");
      this.$refs.btnPlay.classList.remove("is-hidden");
    },
    cancelDraft() {
      this.imageSrc = "";
      this.initializeCamera();
    },
    capture() {
      this.$refs.canvas.width = this.$refs.video.videoWidth;
      this.$refs.canvas.height = this.$refs.video.videoHeight;
      this.$refs.canvas.getContext("2d").drawImage(this.$refs.video, 0, 0);
      this.imageSrc =  this.$refs.canvas.toDataURL("image/png");
      this.stopVideoStream();
    },
    switchCamera() {
      this.useFrontCamera = !this.useFrontCamera;
      this.initializeCamera();
    },
    stopVideoStream() {
      if (this.videoStream) {
        this.videoStream.getTracks().forEach((track) => {
          track.stop();
        });
      }
    },
  },
  mounted() {
    if (
      !"mediaDevices" in navigator ||
      !"getUserMedia" in navigator.mediaDevices
    ) {
      alert("Camera API is not available in your browser");
      return;
    }
    this.initializeCamera();
  },
  destroyed() {
    this.stopVideoStream();
  },
};
</script>

<style scoped>
.cameraContainer {
  margin: 10px
}

.videoComponent {
  width: 100%;
}

.pictureDraft {
  width: 100%;
}
.screenshotsContainer {
  width: 100%;
}
.is-hidden {
  display: none;
}
</style>